import smsLogApi from '@/apis/smsLog';

export const actions = {
  async getSmsLogs({ commit }) {
    const result = await smsLogApi.getSmsLogs();
    commit('setSmsLogs', result);
  },
};
